import { CoreUiException } from "./core-ui-exception";

/**
 * Thrown by a multi-stage workflow only when its primary record already saved and a *later*
 * stage — e.g. an image upload — is what failed. Distinct from a plain
 * `ServiceException`/`Error` thrown for a failure at the initial create/update call, where
 * nothing was written at all.
 *
 * The type itself is the signal a caller branches on: a record that already exists must not
 * be treated the same as one that never got created — an unsaved-changes guard shouldn't
 * re-arm over content that's already persisted, and the user shouldn't be told nothing
 * happened when something did.
 *
 * `message` is expected to already be the full, user-facing sentence (composed by the
 * throwing workflow's own failure message builder) — not a raw error to be prefixed, the way
 * {@link CoreUiException#originalError} is used elsewhere.
 */
export class WorkflowPartialFailureException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("WorkflowPartialFailureException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, WorkflowPartialFailureException.prototype);
    }
}
